module.exports = __webpack_public_path__ + "img/img_01.b89d3066.png";